import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-issuesrememberindoa',
  imports: [],
  templateUrl: './issuesrememberindoa.component.html',
  styleUrl: './issuesrememberindoa.component.css'
})
export class IssuesrememberindoaComponent {
  constructor(private router: Router) {
    this.downloadNotes();
  }

  downloadNotes() {
    const link = document.createElement('a');
    link.href = 'assets/DOA_Issues.doc';
    link.download = 'DOA_Issues.doc';
    link.click();
    this.router.navigate(['/DOA']);
  }
}
